
import { Options, Vue } from 'vue-class-component';
import { ActivityDataRecorderClient, CompanyClient, SpendingClient} from '@/services/Services';
import ActivityDataResultModal from '../modals/activityDataResultModal.vue';
import AddNewPremisesModal from '../modals/addNewPremisesModal.vue';
import InfoModal from '@/components/modals/infoModal.vue';
import * as OM from '@/Model';
import * as VM from '@/viewModel';

@Options({
    components: { },
})
export default class SpendingActivityRecorder extends Vue {

    viewModel = VM;

    //globals
    timeFrameList: string[] = [];
    monthList: OM.TextIdentifier[] = [];
    categories: string[] = [];
    premises: OM.TextIdentifier[] = [];

    destinations: string[] = [];
    subCategories: string[] = [];
    elementNames: string[] = [];
    availableYears: string[] = [];

    timeFrameSelected: string = "";
    selectedYear: string = "";
    spendingEmissionData: OM.SpendingEmissionData = new OM.SpendingEmissionData();
    saveModel: OM.ActivityDataRecorderSpendingVM = new OM.ActivityDataRecorderSpendingVM();
    loaded: boolean = false;

    created() {
        this.init();
    }

    init() {
        this.timeFrameList = Object.values(VM.TimeFrame);
        this.timeFrameSelected = VM.TimeFrame.Year;

        var monthKeys = Object.keys(VM.Months);
        for(var i = 0; i < monthKeys.length; i++) {
            this.monthList.push({
                identifier: i.toString(),
                text: monthKeys[i]
            })
        }

        Promise.all([
            SpendingClient.getCategories(),
            SpendingClient.getDestinations(),
            SpendingClient.getYears(),
            CompanyClient.getPremisesTextIDByCompany(),
        ])
        .then(xs => {
            this.categories = xs[0];
            this.destinations = xs[1];
            this.availableYears = xs[2];
            this.premises = xs[3];

            this.spendingEmissionData.scope = VM.ScopesActivityRecorder.Spending;

            this.loaded = true;
        })
    }

    addPremises() {
        this.$opModal.show(AddNewPremisesModal, {
            callback: () => {
                this.$opModal.closeLast();
                this.init();
            }
        })
    }

    yearUpdated() {
        this.saveModel.year = parseInt(this.selectedYear);
    }

    categoryUpdated() {
        SpendingClient.getSubCategories(this.spendingEmissionData.category)
        .then(x => {
            this.subCategories = x;
            this.spendingEmissionData.subCategory = "";
            this.spendingEmissionData.elementName = "";
        })
    }

    subCategoryUpdated() {
        SpendingClient.getElementNames(this.spendingEmissionData.category, this.spendingEmissionData.subCategory)
        .then(x => {
            this.elementNames = x;
            this.spendingEmissionData.elementName = "";
        })
    }

    get calculateDisabled() {
        var baseCheck = !this.spendingEmissionData.destination || !this.saveModel.selectedPremises.identifier || !this.spendingEmissionData.category ||
            !this.saveModel.year || !this.saveModel.consumption || !this.spendingEmissionData.subCategory || !this.spendingEmissionData.elementName;

        if(this.timeFrameSelected == VM.TimeFrame.Month)
            baseCheck = baseCheck || !this.saveModel.month;

        return baseCheck;
    }

    calculateAndSave() {
        this.saveModel.emissionDataBase = this.spendingEmissionData;
        this.saveModel.selectedPremises = this.premises.find(x => x.identifier == this.saveModel.selectedPremises.identifier);

        Promise.all([
            SpendingClient.getEF(this.spendingEmissionData.category, this.spendingEmissionData.subCategory, this.spendingEmissionData.elementName, this.selectedYear),
            SpendingClient.getEmissionData(this.spendingEmissionData.category, this.spendingEmissionData.subCategory, this.spendingEmissionData.elementName)
        ])
        .then(xs => {
            this.assingEFValueAndSave(xs[0]);

            this.saveModel.emissionDataBase.identifier = xs[1].identifier;
            this.saveModel.emissionDataBase.code = xs[1].code;
            this.saveModel.emissionDataBase.uom = xs[1].uom;
            this.saveModel.emissionDataBase.efValuesPerYear = xs[1].efValuesPerYear;
        })
    }

    assingEFValueAndSave(ef: number) {
        this.saveModel.emissionDataBase.ef = ef;

        if(this.timeFrameSelected == VM.TimeFrame.Year)
            this.saveModel.month = -1;

        ActivityDataRecorderClient.checkIfSpendingRecodAlreadyExist(this.saveModel)
        .then(x => {
            if(!x)
                this.saveSpending();
            else {
                this.$opModal.show(InfoModal, {
                    text: this.$localizationService.getLocalizedValue("Attention", "Attention"),
                    subtitle: this.$localizationService.getLocalizedValue(x, x),
                    confirm: this.$localizationService.getLocalizedValue("Proceed", "Proceed"),
                    confirmCb: () => {
                        this.$opModal.closeLast();
                        this.saveSpending();
                    },
                    deny: this.$localizationService.getLocalizedValue("Avoid", "Avoid"),
                    denyCb: () => {
                        this.$opModal.closeLast();
                    }
                })
            }
        })
    }

    saveSpending() {
        ActivityDataRecorderClient.saveSpending(this.saveModel)
        .then(() => {
            var risValue = this.saveModel.emissionDataBase.ef * this.saveModel.consumption;

            this.$opModal.show(ActivityDataResultModal, {
                emissionValue: risValue
            })
        })
    }

}
